<template>
  <vis-login-layout>
    <vis-loading size="md" v-if="loading" />
    <vis-error size="md" v-else-if="error" with-default :state="state" />
    <div v-else class="ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-content-start">
      <div
        class="identity__tabs ba-w-full ba-text-xl md:ba-text-2xl ba-mb-8 ba-text-center md:ba-w-full ba-uppercase ba-font-semibold"
      >
        <router-link
          :to="{ name: 'login', query: { state } }"
          class="tabs-item hover:ba-no-underline ba-mr-6"
        >
          <span>Вход</span>
        </router-link>
        <span class="tabs-item tabs-item--active">Регистрация</span>
      </div>
      <p class="identity__require ba-w-full ba-mb-2 ba-text-sm ba-text-center">Все поля обязательны для заполнения</p>
      <p class="identity__require ba-w-full ba-mb-4 ba-text-sm ba-text-center">Пароль должен содержать не менее 6 символов</p>
      <form
        @submit.prevent="registerFormSubmit"
        class="identity__register ba-w-full ba-max-w-md ba-relative"
      >
        <p
          v-if="formFieldMessages && formFieldMessages[0]"
          class="error form-message ba-text-center ba-text-sm"
        >{{ formFieldMessages[0] }}</p>
        <p
          v-else-if="formError"
          class="error form-message ba-text-center ba-text-sm"
        >Ошибка при регистрации пользователя</p>
        <p
          v-if="formSuccess"
          class="success form-message ba-text-center ba-text-sm"
        >Пользователь успешно зарегистрирован</p>
        <p
          v-if="formFieldsRequired"
          class="error form-message ba-text-center ba-text-sm"
        >Все поля обязательны для заполнения</p>
        <p
          v-if="formInvalidEmail"
          class="error form-message ba-text-center ba-text-sm"
        >Неверный адрес электронной почты</p>
        <p
          v-if="formInvalidComparePassword"
          class="error form-message ba-text-center ba-text-sm"
        >Указанные пароли не совпадают</p>
        <div class="md:ba-flex ba-justify-between ba-items-start">
          <vis-form-input
            v-model="form.firstName"
            :disabled="formLoading"
            label="Имя"
            type="text"
            icon="fas fa-user"
            autocomplete="off"
          />
          <vis-form-input
            v-model="form.lastName"
            :disabled="formLoading"
            label="Фамилия"
            type="text"
            icon="fas fa-user"
            autocomplete="off"
          />
        </div>

        <div class="md:ba-flex ba-justify-between ba-items-start">
          <vis-form-input
            v-model="form.email"
            :disabled="formLoading"
            label="Электронная почта"
            icon="fas fa-envelope"
            type="text"
            autocomplete="off"
          />
          <vis-form-input
            v-model="form.password"
            :disabled="formLoading"
            label="Пароль"
            type="password"
            icon="fas fa-unlock-alt"
            autocomplete="off"
          />
        </div>

        <div class="md:ba-flex ba-justify-between ba-items-start">
          <vis-form-input
            v-model="form.repeatPassword"
            :disabled="formLoading"
            label="Подтверждение пароля"
            type="password"
            icon="fas fa-unlock-alt"
            autocomplete="off"
          />
          <vis-captcha v-if="true || showCaptcha" :result.sync="captchResult" :refresh.sync="refreshCaptcha" />
        </div>
        <button
            type="submit"
            :disabled="formLoading"
            class="btn ba-w-full md:ba-w-auto btn--login ba-mt-2 ba-mx-auto"
          >Отправить</button>
      </form>
      <a
        v-if="false"
        target="_blank"
        href="https://domain/privacy/privacy-policy"
        class="ba-w-full ba-block ba-text-center ba-text-sm ba-underline hover:ba-no-underline"
      >Политика конфиденциальности</a>
      <a
        v-if="false"
        target="_blank"
        href="https://domain/privacy/user-agreement"
        class="ba-w-full ba-block ba-text-center ba-text-sm ba-underline hover:ba-no-underline"
      >Пользовательское соглашение</a>
    </div>
  </vis-login-layout>
</template>

<script>
import VisLoginLayout from "./vis-login-layout";
import VisCaptcha from "./vis-captcha";
import { createSettings } from "@/utils/settings";
import { registerMixin } from "@ba/visary-account-common-vue";

export default {
  name: "vis-page-register",
  components: {
    VisLoginLayout,
    VisCaptcha
  },
  mixins: [registerMixin],
  data() {
    return {
      refreshCaptcha: true
    }
  },
  computed: {
    formMessages() {
      return {
        BadRequest: {
          email: {
            EmailExists: "Пользователь с указанным email уже зарегистрирован"
          }
        }
      }
    }
  },
  watch: {
    registerInfo() {
      const settings = createSettings(this.registerInfo?.clientId);
      if (!settings.canRegister) {
        this.$router.replace({ name: "login", query: { state: this.state } });
      }
    }
  }
};
</script>
